import { render, staticRenderFns } from "./OrderAccount.vue?vue&type=template&id=0997809e"
import script from "./OrderAccount.vue?vue&type=script&lang=js"
export * from "./OrderAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports